module.exports = __webpack_public_path__ + "img/xmasParty20.ef7e4b04.jpg";